module.exports = __webpack_public_path__ + "img/desktop-black.145f9c29.png";